var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShotgun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.125 27.8204C117.63 25.8764 118.412 24.5714 118.022 23.1704C117.632 21.7709 116.343 20.0984 116.343 20.0984L114.738 19.5839L112.434 19.6724L111.924 20.4539L110.871 19.8644H107.567L102.12 20.9069L100.886 20.9339L99.761 20.5589L93.5345 20.7419L93.5615 20.0294L90.5435 19.0964H86.84C86.84 19.0964 84.047 18.1784 83.411 18.5759C82.775 18.9734 82.424 20.1944 82.424 20.1944H73.8665L70.1915 18.9869L68.8265 18.7394L60.812 18.7124L59.288 18.1859L45.7265 18.3284L44.63 18.7394L42.2435 18.4094H40.652L38.8685 18.6569H37.6895L35.7425 19.8644L21.9995 19.9739L20.231 19.1699L18.0305 19.5689L15.9935 19.8359L13.5215 19.1969L12.125 18.1904L7.68198 18.1859L6.92148 19.3229L5.13198 19.9739L4.82298 21.8159H2.39298L2.08398 24.9179L3.48348 25.6784L2.24898 26.1719V28.9154L5.04648 30.0134L16.649 30.2864L17.8415 29.6279H19.034L20.2265 29.8199L23.066 30.0134L23.93 29.5874L24.341 30.4274L23.765 31.4279L23.8055 33.5789L25.739 34.0319L28.496 35.5544L29.7305 35.4179L30.512 35.9249H32.3225L33.227 35.4719L34.1735 36.1229L36.107 35.5139L37.136 35.8964L38.4935 35.4734L40.262 36.1244L41.3315 35.5154L42.731 35.9264L44.3765 35.5154H47.9555V33.2939L48.902 32.7509H50.8775L54.539 31.0514H61.3685L62.0675 31.4429H69.2675L69.8435 30.6194H71.7365L71.654 31.8119L73.916 32.8274L75.0695 32.4689L76.139 34.1054L82.598 34.3214L84.5735 38.8064L85.7255 39.9584V41.3579L85.355 42.8804H86.7545L90.3755 41.6459C90.3755 41.6459 91.214 41.0174 90.7295 39.5474C90.245 38.0774 87.6185 32.3879 87.6185 32.3879C87.6185 32.3879 88.028 29.7134 90.1475 28.8899C92.267 28.0664 92.309 28.4789 92.309 28.4789L93.2555 27.7244C93.2555 27.7244 95.2685 27.7934 95.948 29.8229L100.989 32.0054L110.589 35.7194L114.567 35.9384L115.775 35.8289L117.119 34.7324C117.119 34.7324 117.068 33.7739 117.119 33.3029C117.17 32.8319 116.613 29.7644 117.119 27.8204H117.125ZM82.5635 33.2789C82.5635 33.2789 77.8175 33.3344 77.1605 33.2789C76.502 33.2234 76.145 32.0999 76.145 32.0999C76.145 32.0999 76.145 31.8254 76.2815 31.2494C76.418 30.6734 77.2685 30.5084 77.2685 30.5084H79.5185L82.5635 30.7559V33.2789Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9043 21.8175H18.4183",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4648 21.8174H25.9788",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8301 21.8175H33.3441",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9757 24.7755H11.5997C11.275 24.7755 11.0117 25.0387 11.0117 25.3635C11.0117 25.6882 11.275 25.9515 11.5997 25.9515H25.9757C26.3005 25.9515 26.5637 25.6882 26.5637 25.3635C26.5637 25.0387 26.3005 24.7755 25.9757 24.7755Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4941 30.975H26.8251L27.5376 29.823H28.8261L30.5856 28.2315C30.5856 28.2315 30.9936 27.8745 31.5966 27.8745H33.5571C33.5571 27.8745 33.5436 28.4235 33.9816 28.4235C34.4196 28.4235 34.4211 27.8745 34.4211 27.8745H35.6286L36.6981 29.8215H45.9426L47.7801 30.015V33.6345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9432 29.823C45.9432 29.823 46.1622 31.194 45.4497 32.0715C44.7372 32.949 44.2422 32.8395 44.2422 33.6345V35.6385",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8271 29.8229H36.7277",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1445 35.556V29.823",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4209 29.823V35.808",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5598 30.0165V35.556",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3008 29.823V35.6385",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4258 30.0165V35.556",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.208 30.0165V35.418",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.251 30.0165V35.556",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0068 30.0165V35.6385",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2402 30.0165V35.253",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2422 33.636V29.823",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74219 26.5455H35.8217L37.3862 27.8745H44.0102V26.8335H48.2477V32.6355",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8296 26.5455V28.89H24.8371L23.7676 29.3835",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.083 26.751V28.89",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5332 26.751V29.823",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2295 26.751V29.823",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0889 26.751V29.3835",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12866 27.48H15.4967",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48315 22.0604V25.2689",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5889 19.3035H8.37891V21.8175H11.5889V19.3035Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5671 28.794C51.5671 28.2563 51.1313 27.8205 50.5936 27.8205C50.056 27.8205 49.6201 28.2563 49.6201 28.794V30.249C49.6201 30.7866 50.056 31.2225 50.5936 31.2225C51.1313 31.2225 51.5671 30.7866 51.5671 30.249V28.794Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3747 20.1945V20.853L61.8813 21.429H57.2717L56.8877 22.224H51.1277L50.5938 21.4845V20.1945L51.0737 19.893H56.5322L56.9987 20.1945H69.3692L70.1912 18.9885",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6504 18.741V21.456H44.9014L45.1099 20.991H47.0419V20.1945H44.1334V18.741",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5413 23.925H49.2363",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9316 26.4209H94.5366L98.4441 27.8204H109.06",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1396 24.981V23.5005C96.1396 23.5005 99.2672 23.295 99.2672 23.5005V24.981",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M111.981 24.8579V31.9064C111.981 31.9064 113.421 32.0174 113.421 33.5399C113.421 35.0624 111.981 34.7744 111.981 34.7744V35.7209",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M109.923 20.1945V21.402L113.709 22.7595V23.925H115.354",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4648 23.1705H93.5343",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6445 20.6069L81.246 21.4559H91.203H93.2595",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2441 23.1704V21.4559",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4202 23.925V30.756",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5935 26.6685H67.751V31.221",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7646 25.1055V25.791",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6445 25.1055V25.791",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5244 25.1055V25.791",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4043 25.1055V25.791",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5566 26.8605H67.7506",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5566 28.4235H67.7506",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5566 29.7134H67.5856",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24898 26.175V28.9185L5.04648 30.0165H16.8965L17.843 29.631H19.0355L19.406 30.0165H23.0675L23.5205 29.5905H23.9315L24.3425 30.0165V30.7005L23.807 31.1115V33.5805L25.7405 34.0335L28.4975 35.556H30.143L30.5135 35.9265H32.324L32.6945 35.4735H33.23L33.683 35.9265H35.246L35.657 35.5155H36.11L36.5015 35.907C36.5015 35.907 37.139 35.886 37.6325 35.907L38.126 35.928L38.4965 35.475H39.032L39.443 35.928H40.9235L41.3345 35.517H41.87L42.323 35.928H43.928L44.381 35.517H47.96V33.2955L48.371 32.7525H50.8805L54.542 31.053H61.3715L61.742 31.4445H69.272L69.848 30.621H71.741L72.1115 31.053L71.6585 31.8135L74.498 33.0885L75.074 32.472L75.485 33.4185L76.349 34.323H82.6025L83.138 34.6515L84.578 38.8065L85.73 39.9585V41.358L85.277 42.222C85.277 42.222 85.154 42.4695 85.3595 42.8805C85.565 43.2915 86.759 42.8805 86.759 42.8805L90.38 41.646C90.38 41.646 90.833 41.481 90.833 40.329C90.833 39.177 90.0095 37.449 89.27 35.967C88.529 34.4865 87.5825 32.799 87.6245 32.388C87.665 31.977 87.6245 30.7425 88.982 29.631C90.3395 28.5195 91.7795 28.356 92.315 28.479C92.315 28.479 92.8085 28.602 93.014 27.6555C93.014 27.6555 93.755 27.696 94.2065 27.903C94.6595 28.1085 94.988 28.1085 95.399 28.932C95.81 29.7555 96.0155 30.084 97.0865 30.495C98.156 30.906 110.595 35.721 110.595 35.721H113.997C113.997 35.721 114.326 35.9685 114.573 35.94C114.821 35.9115 115.122 35.4735 115.122 35.4735C115.122 35.4735 115.259 35.94 115.781 35.8305C116.301 35.721 117.125 34.734 117.125 34.734C117.125 34.734 117.564 33.993 117.317 33.417C117.069 32.841 116.768 29.4945 116.933 28.3695C117.098 27.2445 117.783 25.5435 117.948 24.858C118.113 24.1725 118.415 21.7035 116.193 19.9755H115.535L115.425 19.674H112.436C112.436 19.674 111.915 19.9215 111.915 20.223C111.915 20.5245 111.971 20.7165 111.971 20.7165H111.285V19.812H107.856L102.123 20.9085L100.889 20.9355L100.614 20.7165L93.5375 20.7435L93.5645 20.031L91.7 19.3185H91.0685L90.548 19.0995H86.8445C86.8445 19.0995 84.623 18.1665 83.4155 18.579C82.208 18.99 82.4285 20.1975 82.4285 20.1975H73.871L70.799 19.0185L70.196 18.9915C70.196 18.9915 70.031 18.744 69.401 18.744C68.771 18.744 60.815 18.717 60.815 18.717L60.3755 18.333H45.728L45.2615 18.717H43.8905L43.589 18.4695L42.986 18.525L42.7115 18.1965H42.053V18.498H41.3945L41.1755 18.1965H40.271L40.244 18.663H37.6925C37.6925 18.663 36.788 18.9105 36.074 19.8705H21.653C21.653 19.8705 21.2 19.329 20.7275 19.2255C20.255 19.122 19.349 19.2045 19.349 19.2045L19.1435 19.575H18.65L18.5465 19.842H18.032V19.575H17.435C17.435 19.575 17.5175 19.842 17.435 19.842H15.995C15.995 19.842 15.9335 19.533 14.987 19.41C14.0405 19.287 12.992 19.122 12.992 19.122C12.992 19.122 12.1895 18.114 12.128 18.1965C12.0665 18.279 7.23198 18.3 7.23198 18.3L7.21098 18.999C7.21098 18.999 7.08798 19.2465 6.92298 19.3275C6.75798 19.41 5.64798 19.6365 5.60598 20.007L5.56548 20.3775H5.11248L4.82448 20.727V21.822H2.39298L2.08398 21.9825V24.924L2.33148 25.2735H4.38798C4.38798 25.2735 4.63548 25.356 4.63548 25.6845C4.63548 26.013 4.49148 26.1165 4.26498 26.1165C4.03848 26.1165 2.61948 26.0955 2.61948 26.0955L2.24898 26.178V26.175Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6321 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2217 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.907 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1816 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28.459 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7334 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0088 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2849 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5596 19.3035V19.866",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82031 21.8176V23.7871H39.4028L40.3493 24.1576V26.2966H43.0238V25.6381H46.9328V26.2966H49.5653L52.4453 24.0571H66.0638C66.0638 24.0571 66.3113 24.6106 67.0508 24.6106C67.7903 24.6106 68.1203 24.0571 68.1203 24.0571H70.3013L73.5923 25.2691V26.6686C73.5923 26.6686 76.2248 28.0261 76.5548 28.1086C76.8848 28.1911 84.1253 28.1086 84.1253 28.1086L88.5668 30.0166",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5185 30.5085H77.27C77.27 30.5085 76.4195 30.6735 76.283 31.2495C76.1465 31.8255 76.1465 32.1 76.1465 32.1C76.1465 32.1 76.5035 33.225 77.162 33.279C77.8205 33.333 82.565 33.279 82.565 33.279V30.756L79.52 30.5085H79.5185Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8756 30.5085C79.8756 30.5085 80.1501 31.3035 79.8756 31.743C79.6011 32.1825 79.7106 32.5665 80.5881 32.2095C81.4656 31.8525 81.5481 30.6255 81.5481 30.6255L79.8756 30.5085Z",
    fill: "#FAFAFB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5342 20.7435V24.8025H94.7417V25.407H109.28L110.267 24.858H113.997V35.7195",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8682 20.1945L76.1452 21.8175H77.3377L77.9542 21.36H79.0657C79.0657 21.36 78.8602 21.936 79.3537 22.1415C79.8472 22.347 80.4652 22.7175 80.4652 23.1705H79.1902C79.1902 23.1705 78.2437 23.211 78.2437 24.075C78.2437 24.939 79.3552 24.816 79.3552 24.816L89.6002 24.822L91.8637 26.421H92.9332V27.6555",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M115.533 19.9755V35.4735",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotgun);
export default __webpack_public_path__ + "static/media/Shotgun.a91c53249c9fc741f5124f894e0012b7.svg";
export { ForwardRef as ReactComponent };